import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toggleActive } from "../api";
import { projectsKeys } from "../queries/index";
import type { Project, ProjectsListResponse } from "../../types";

interface ToggleActiveParams {
  id: number;
  value: boolean;
}

// Mutation hook for toggling active status
export const useToggleActiveMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, value }: ToggleActiveParams) => {
      const response = await toggleActive(id, value);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      const { id } = variables;

      // Update all list queries
      queryClient.setQueriesData<ProjectsListResponse>(
        { queryKey: [...projectsKeys.all, "list"] },
        (oldData) => {
          if (!oldData?.data) return oldData;
          return {
            ...oldData,
            data: oldData.data.map((project: Project) =>
              project.id === id
                ? { ...project, isActive: !project.isActive }
                : project,
            ),
          };
        },
      );
    },
  });
};
